import { render, staticRenderFns } from "./transfer.vue?vue&type=template&id=57d4f4c1&scoped=true&lang=html&"
import script from "./transfer.vue?vue&type=script&lang=js&"
export * from "./transfer.vue?vue&type=script&lang=js&"
import style0 from "./transfer.vue?vue&type=style&index=0&id=57d4f4c1&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d4f4c1",
  null
  
)

component.options.__file = "transfer.vue"
export default component.exports